module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "height": "100%"
    }
  }, [_vm._v("\n    窗口" + _vm._s(_vm.windowIndex + 1) + "/" + _vm._s(_vm.windowCount) + " " + _vm._s(_vm.last_count) + "/" + _vm._s(_vm.total) + "\n    ")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45b94fdf","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/score/ScoreUpOss.vue
// module id = 2357
// module chunks = 0